// 시안 v6 사이드바. 메뉴 열쇠는 기존 Admin.js 의 view 값을 그대로 쓴다.
// 그리는 메뉴는 로그인 응답의 user.menus(→ views)로만 정한다(계약 §1·§2).
// 접기(데스크톱)·아이콘만(641~900px)·서랍(640px 이하)은 shell_v6.css 가 처리한다.
export const MENUS = [
    { key: "dashboard", icon: "fa-gauge", label: "대시보드" },
    { key: "notice", icon: "fa-bullhorn", label: "공지사항 관리" },
    { key: "knowledge", icon: "fa-book", label: "지식베이스 관리" },
    { key: "assistant", icon: "fa-sliders", label: "AI 모델 설정" },
    { key: "chart", icon: "fa-chart-simple", label: "분석 및 보고서" },
    { key: "chatbot", icon: "fa-comments", label: "챗봇 운영 설정" },
    { key: "inquiry", icon: "fa-clipboard-list", label: "문의 관리" },
    { key: "chat_history", icon: "fa-comment-dots", label: "대화 기록" },
];

export const menuLabel = (key) => MENUS.find((m) => m.key === key)?.label || "";

export default function Sidebar({ view, views = [], me, onMenu, unread, onFold, open, onClose, onLogout }) {
    const menus = MENUS.filter((m) => views.includes(m.key));
    const roleText = me?.role === "owner" ? "대표관리자" : me?.role === "staff" ? "직원" : "로그인 전";
    // 이름이 권한 이름과 같으면(대표 계정 이름이 「대표관리자」) 권한을 또 쓰지 않는다
    const roleLine = [me?.name === roleText ? "" : roleText, me?.team].filter(Boolean).join(" · ");
    return (
        <>
            <aside className={`v6sb ${open ? "open" : ""}`}>
                <div className="v6sb-brand">
                    <div className="v6sb-logo">G</div>
                    <div className="v6sb-name"><h2>가람포스텍</h2><p>AI 관리센터</p></div>
                    <button className="v6sb-fold" type="button" title="메뉴 접기" aria-label="메뉴 접기/펼치기" onClick={onFold}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="4" width="18" height="16" rx="3" /><path className="line" d="M9 4v16" />
                            <path className="fill" d="M3 7a3 3 0 0 1 3-3h3v16H6a3 3 0 0 1-3-3z" fill="currentColor" stroke="none" />
                        </svg>
                    </button>
                </div>
                <ul className="v6sb-nav">
                    {menus.map((m) => (
                        <li key={m.key} className={view === m.key ? "on" : ""} title={m.label} tabIndex={0}
                            onClick={() => { onMenu(m.key); onClose(); }}
                            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onMenu(m.key); onClose(); } }}>
                            <i className={`fa-solid ${m.icon}`}></i>{m.label}
                            {m.key === "inquiry" && unread > 0 && <span className="v6sb-badge">{unread > 99 ? "99+" : unread}</span>}
                        </li>
                    ))}
                </ul>
                <div className="v6sb-user">
                    <div className="v6sb-ava"><i className="fa-solid fa-user"></i></div>
                    <div style={{ minWidth: 0 }}>
                        <b>{me?.name || "로그인 전"}</b>
                        {roleLine && <em>{roleLine}</em>}
                        {me?.email && <span>{me.email}</span>}
                    </div>
                    <button className="v6sb-out" type="button" title="로그아웃" aria-label="로그아웃" onClick={onLogout}><i className="fa-solid fa-right-from-bracket"></i></button>
                </div>
            </aside>
            <div className={`v6sb-dim ${open ? "on" : ""}`} onClick={onClose}></div>
        </>
    );
}
